/**
 * 服务
 */

import axios from '@/util/request'

export default {
  getDocumentaryFile: (fileUrl, params) => axios({ url: fileUrl, method: 'GET', params, responseType: 'blob' }), // 获取跟单文件数据
  getDocumentaryFileList: (params) => axios({ url: '/api/message/user/documentaryFileList', method: 'GET', params }) // 用户获取跟单文件列表
}
